
import React from 'react';
import { UserIcon, CheckCircleIcon } from "@heroicons/react/24/outline";

export interface Employee {
    _id: string;
    fullName: string;
    employeeType: "Master" | "Karigar" | "job-work" | "Group Work";
    availabilityStatus: "Available" | "Busy"; 
}

// This component now takes a single employee and its state
interface EmployeeCardProps {
    employee: Employee;
    onSelect: (employeeId: string, employeeType: string) => void;
    isSelected: boolean;
    isAssigned: boolean;
}

const EmployeeCard: React.FC<EmployeeCardProps> = ({ 
    employee,
    onSelect,
    isSelected,
    isAssigned,
}) => {
    const availabilityColor = employee.availabilityStatus === 'Available' ? 'text-green-600' : 'text-amber-500';

    return (
        <button
            onClick={() => onSelect(employee._id, employee.employeeType)}
            className={`flex items-center justify-start gap-3 px-4 py-3 rounded-lg font-medium text-sm border shadow-sm transition-all duration-200 text-left w-full
            ${isAssigned ? 'border-green-500 bg-green-50 text-green-700 ring-1 ring-green-300' 
            : isSelected ? 'border-indigo-500 bg-indigo-50 text-indigo-700 ring-1 ring-indigo-300' 
            : 'border-gray-200 bg-white text-gray-800 hover:bg-indigo-50 hover:border-indigo-300'}`}
        >
            <div className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center bg-indigo-100`}>
                <UserIcon className={`h-5 w-5 ${availabilityColor}`} />
            </div>
            <div className="flex flex-col">
                <span className="truncate font-semibold">{employee.fullName}</span>
                <span className="text-xs text-gray-500 capitalize">
                    {employee.employeeType.replace('-', ' ')} 
                </span>
            </div>


            {isAssigned && !isSelected && (
                <span className="ml-auto flex items-center gap-1 text-xs font-medium text-green-600">
                    <CheckCircleIcon className="h-4 w-4" />
                    Assigned
                </span>
            )}
            

            {isAssigned && isSelected && (
                <span className="ml-auto flex items-center gap-1 text-xs font-medium text-green-700">
                    <CheckCircleIcon className="h-4 w-4" />
                    Assigned
                </span>
            )}
        </button>
    );
};

export default EmployeeCard; 
